// extracted by mini-css-extract-plugin
export default {"container":"uM-z","topReviewHeading":"vM-z","criticalReview":"wM-z","favorableReview":"xM-z","vsSeparator":"yM-z"};